export const CAPCITO = 'capcito'
export const COLLECTOR = 'collector_bank'
